// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-view {
  padding: 1.5rem;
  max-width: 1600px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
}

.comparison-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ddd;
}

.comparison-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.btn-close-comparison {
  padding: 0.6rem 1.2rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  color: #555;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-close-comparison:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

/* Selector de resultados */
.comparison-selector {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.selector-label {
  font-weight: 500;
  color: #555;
  margin-right: 1rem;
}

.selector-page-label {
  font-weight: 500;
  color: #555;
  display: block;
  margin-bottom: 0.75rem;
}

.results-groups {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.results-group {
  flex: 1 1;
  min-width: 200px;
}

.results-group .group-title {
  display: block;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
}

.results-group.very-similar .group-title {
  color: #2e7d32;
  border-bottom-color: #2e7d32;
}

.results-group.related .group-title {
  color: #666;
  border-bottom-color: #999;
}

.results-group.rejected .group-title {
  color: #b71c1c;
  border-bottom-color: #b71c1c;
}

.results-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.result-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 20px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}

.result-chip:hover {
  border-color: var(--button-color, #007bff);
  background: #f8f9fa;
}

.result-chip.selected {
  border-color: var(--button-color, #007bff);
  background: #e3f2fd;
}

.result-chip.no-score {
  padding: 0.5rem 0.75rem;
}

.chip-score {
  font-weight: 700;
  color: var(--button-color, #007bff);
}

.chip-name {
  font-size: 0.85rem;
  color: #555;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* No results message */
.no-results-message {
  padding: 1rem;
  text-align: center;
  color: #666;
  font-style: italic;
}

/* Stage buttons */
.stage-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.stage-counts {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.25rem;
  width: 100%;
}

.stage-counts span {
  font-size: 11px;
  color: #888;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 10px;
}

.btn-stage {
  padding: 0.6rem 1.2rem;
  border: 1px solid var(--button-color, #007bff);
  border-radius: 4px;
  background: white;
  color: var(--button-color, #007bff);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-stage:hover:not(:disabled) {
  background: var(--button-color, #007bff);
  color: white;
}

.btn-stage:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.stage-complete-message {
  color: #28a745;
  font-weight: 500;
  font-size: 0.9rem;
}

/* Heuristic search */
.heuristic-section {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}

.heuristic-status {
  color: #555;
  font-weight: 500;
  font-size: 0.9rem;
}

.results-group.heuristic .group-title {
  color: #666;
  border-bottom-color: #999;
}

.heuristic-no-results {
  color: #666;
  font-style: italic;
  font-size: 0.9rem;
}

/* Paneles lado a lado */
.comparison-panels {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0;
  align-items: stretch;
}

.comparison-panel {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.comparison-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
}

.comparison-divider span {
  background: #333;
  color: white;
  padding: 0.5rem;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.8rem;
}

/* Embedded Preview */
.embedded-preview {
  height: 100%;
}

.embedded-preview.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #999;
}

.embedded-header {
  padding: 1rem 1.5rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-left: 4px solid #ccc;
}

.embedded-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.embedded-filename {
  font-size: 0.85rem;
  color: #666;
  word-break: break-word;
}

.embedded-actions {
  display: flex;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: #f0f4f8;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.btn-embedded-action {
  padding: 0.35rem 0.7rem;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: white;
  color: #475569;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-embedded-action:hover {
  background: #e2e8f0;
  border-color: #94a3b8;
}

.btn-embedded-action.btn-location {
  color: #1976d2;
  border-color: #90caf9;
}

.btn-embedded-action.btn-location:hover {
  background: #e3f2fd;
}

.embedded-content {
  padding: 1rem;
}

/* Imagen */
.embedded-image-section {
  margin-bottom: 1rem;
}

.embedded-image {
  position: relative;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.embedded-image img {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  background: #fafafa;
}

.embedded-image:hover .zoom-hint {
  opacity: 1;
}

.zoom-hint {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.7);
  color: white;
  text-align: center;
  padding: 0.5rem;
  font-size: 0.8rem;
  opacity: 0;
  transition: opacity 0.2s;
}

.embedded-image-loading {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 4px;
  color: #999;
}

/* Resumen */
.embedded-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.summary-item {
  text-align: center;
}

.summary-item .label {
  display: block;
  font-size: 0.75rem;
  color: #666;
  margin-bottom: 0.25rem;
}

.summary-item .value {
  font-weight: 600;
  color: #333;
}

.summary-item .value.status {
  color: #2e7d32;
  text-transform: capitalize;
}

/* Operaciones */
.embedded-operations {
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.embedded-operations h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #333;
}

.embedded-category {
  background: #fafafa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.embedded-category h5 {
  margin: 0;
  padding: 0.75rem 1rem;
  background: #e9ecef;
  font-size: 0.9rem;
  color: #333;
}

.category-fields {
  padding: 0.75rem 1rem;
}

.field-row {
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.field-row:last-child {
  border-bottom: none;
}

.field-row.small {
  font-size: 0.85rem;
}

.field-label {
  color: #666;
}

.field-value {
  font-weight: 500;
  color: #333;
}

.array-section {
  padding: 0.75rem 1rem;
  border-top: 1px solid #e9ecef;
}

.array-section h6 {
  margin: 0 0 0.5rem 0;
  font-size: 0.85rem;
  color: #555;
}

.array-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.5rem;
}

.array-item {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 0.5rem;
}

.array-item-title {
  font-weight: 600;
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 0.5rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #eee;
}

/* Query metadata details */
.query-metadata-details {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.metadata-detail-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  /* que un valor largo (o el historial de la referencia desplegado) baje de línea
     en vez de desbordar la columna */
  flex-wrap: wrap;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.metadata-detail-row:last-child {
  border-bottom: none;
}

.metadata-detail-row .label {
  color: #666;
  font-weight: 500;
}

.metadata-detail-row .value {
  color: #333;
  font-weight: 600;
}

.query-note {
  font-size: 0.85rem;
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 0.5rem;
  background: #fff3cd;
  border-radius: 4px;
  margin-top: 0.5rem;
}

/* Modal de imagen */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.image-modal-box {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.image-modal-box img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
}

/* Multi-query images for PDFs with multiple drawing pages */
.multi-query-images {
  height: 100%;
}

.query-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.query-image-item {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
  cursor: pointer;
}

.query-image-item:hover {
  border-color: #90caf9;
}

.query-image-item.highlighted {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
}

.query-image-label {
  background: #f5f5f5;
  padding: 0.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.85rem;
  color: #555;
}

.query-image-item.highlighted .query-image-label {
  background: #e3f2fd;
  color: #1976d2;
}

.query-image-item img {
  width: 100%;
  height: auto;
  max-height: 250px;
  object-fit: contain;
  background: #fafafa;
}

.chip-query-page {
  font-size: 0.75rem;
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
}

/* Responsive */
@media (max-width: 1000px) {
  .comparison-panels {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .comparison-divider {
    padding: 0.5rem 0;
  }

  .comparison-panel {
    max-height: none;
  }

  .query-images-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* NUBBI-102 — botón de entrada a búsqueda por elementos */
.comparison-header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.btn-elements-search {
  padding: 0.6rem 1.2rem;
  border: 1px solid #3498db;
  border-radius: 4px;
  background: #3498db;
  color: white;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-elements-search:hover {
  background: #2980b9;
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/ComparisonView.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mCAAmC;EACnC,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT;qCACmC;EACnC,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".comparison-view {\n  padding: 1.5rem;\n  max-width: 1600px;\n  margin: 0 auto;\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.comparison-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #ddd;\n}\n\n.comparison-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.btn-close-comparison {\n  padding: 0.6rem 1.2rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.btn-close-comparison:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n/* Selector de resultados */\n.comparison-selector {\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.selector-label {\n  font-weight: 500;\n  color: #555;\n  margin-right: 1rem;\n}\n\n.selector-page-label {\n  font-weight: 500;\n  color: #555;\n  display: block;\n  margin-bottom: 0.75rem;\n}\n\n.results-groups {\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.results-group {\n  flex: 1;\n  min-width: 200px;\n}\n\n.results-group .group-title {\n  display: block;\n  font-weight: 600;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.results-group.very-similar .group-title {\n  color: #2e7d32;\n  border-bottom-color: #2e7d32;\n}\n\n.results-group.related .group-title {\n  color: #666;\n  border-bottom-color: #999;\n}\n\n.results-group.rejected .group-title {\n  color: #b71c1c;\n  border-bottom-color: #b71c1c;\n}\n\n.results-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.result-chip {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 20px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.result-chip:hover {\n  border-color: var(--button-color, #007bff);\n  background: #f8f9fa;\n}\n\n.result-chip.selected {\n  border-color: var(--button-color, #007bff);\n  background: #e3f2fd;\n}\n\n.result-chip.no-score {\n  padding: 0.5rem 0.75rem;\n}\n\n.chip-score {\n  font-weight: 700;\n  color: var(--button-color, #007bff);\n}\n\n.chip-name {\n  font-size: 0.85rem;\n  color: #555;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* No results message */\n.no-results-message {\n  padding: 1rem;\n  text-align: center;\n  color: #666;\n  font-style: italic;\n}\n\n/* Stage buttons */\n.stage-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.stage-counts {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.25rem;\n  width: 100%;\n}\n\n.stage-counts span {\n  font-size: 11px;\n  color: #888;\n  background: #f5f5f5;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.btn-stage {\n  padding: 0.6rem 1.2rem;\n  border: 1px solid var(--button-color, #007bff);\n  border-radius: 4px;\n  background: white;\n  color: var(--button-color, #007bff);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-stage:hover:not(:disabled) {\n  background: var(--button-color, #007bff);\n  color: white;\n}\n\n.btn-stage:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  vertical-align: middle;\n  margin-right: 6px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.stage-complete-message {\n  color: #28a745;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n/* Heuristic search */\n.heuristic-section {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.heuristic-status {\n  color: #555;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.results-group.heuristic .group-title {\n  color: #666;\n  border-bottom-color: #999;\n}\n\n.heuristic-no-results {\n  color: #666;\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\n/* Paneles lado a lado */\n.comparison-panels {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0;\n  align-items: stretch;\n}\n\n.comparison-panel {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.comparison-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.5rem;\n}\n\n.comparison-divider span {\n  background: #333;\n  color: white;\n  padding: 0.5rem;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 0.8rem;\n}\n\n/* Embedded Preview */\n.embedded-preview {\n  height: 100%;\n}\n\n.embedded-preview.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: #999;\n}\n\n.embedded-header {\n  padding: 1rem 1.5rem;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  border-left: 4px solid #ccc;\n}\n\n.embedded-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.embedded-filename {\n  font-size: 0.85rem;\n  color: #666;\n  word-break: break-word;\n}\n\n.embedded-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  background: #f0f4f8;\n  border-bottom: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.btn-embedded-action {\n  padding: 0.35rem 0.7rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  background: white;\n  color: #475569;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn-embedded-action:hover {\n  background: #e2e8f0;\n  border-color: #94a3b8;\n}\n\n.btn-embedded-action.btn-location {\n  color: #1976d2;\n  border-color: #90caf9;\n}\n\n.btn-embedded-action.btn-location:hover {\n  background: #e3f2fd;\n}\n\n.embedded-content {\n  padding: 1rem;\n}\n\n/* Imagen */\n.embedded-image-section {\n  margin-bottom: 1rem;\n}\n\n.embedded-image {\n  position: relative;\n  cursor: pointer;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.embedded-image img {\n  width: 100%;\n  max-height: 300px;\n  object-fit: contain;\n  background: #fafafa;\n}\n\n.embedded-image:hover .zoom-hint {\n  opacity: 1;\n}\n\n.zoom-hint {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0,0,0,0.7);\n  color: white;\n  text-align: center;\n  padding: 0.5rem;\n  font-size: 0.8rem;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.embedded-image-loading {\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  border-radius: 4px;\n  color: #999;\n}\n\n/* Resumen */\n.embedded-summary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.summary-item {\n  text-align: center;\n}\n\n.summary-item .label {\n  display: block;\n  font-size: 0.75rem;\n  color: #666;\n  margin-bottom: 0.25rem;\n}\n\n.summary-item .value {\n  font-weight: 600;\n  color: #333;\n}\n\n.summary-item .value.status {\n  color: #2e7d32;\n  text-transform: capitalize;\n}\n\n/* Operaciones */\n.embedded-operations {\n  border-top: 1px solid #eee;\n  padding-top: 1rem;\n}\n\n.embedded-operations h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.embedded-category {\n  background: #fafafa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.embedded-category h5 {\n  margin: 0;\n  padding: 0.75rem 1rem;\n  background: #e9ecef;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.category-fields {\n  padding: 0.75rem 1rem;\n}\n\n.field-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.3rem 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.field-row:last-child {\n  border-bottom: none;\n}\n\n.field-row.small {\n  font-size: 0.85rem;\n}\n\n.field-label {\n  color: #666;\n}\n\n.field-value {\n  font-weight: 500;\n  color: #333;\n}\n\n.array-section {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.array-section h6 {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.85rem;\n  color: #555;\n}\n\n.array-items {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.5rem;\n}\n\n.array-item {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 0.5rem;\n}\n\n.array-item-title {\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: #555;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.25rem;\n  border-bottom: 1px solid #eee;\n}\n\n/* Query metadata details */\n.query-metadata-details {\n  background: #f8f9fa;\n  border-radius: 4px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.metadata-detail-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  /* que un valor largo (o el historial de la referencia desplegado) baje de línea\n     en vez de desbordar la columna */\n  flex-wrap: wrap;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.metadata-detail-row:last-child {\n  border-bottom: none;\n}\n\n.metadata-detail-row .label {\n  color: #666;\n  font-weight: 500;\n}\n\n.metadata-detail-row .value {\n  color: #333;\n  font-weight: 600;\n}\n\n.query-note {\n  font-size: 0.85rem;\n  color: #999;\n  font-style: italic;\n  text-align: center;\n  padding: 0.5rem;\n  background: #fff3cd;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n}\n\n/* Modal de imagen */\n.image-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.image-modal-box {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.image-modal-box img {\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: contain;\n}\n\n.modal-close {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n}\n\n/* Multi-query images for PDFs with multiple drawing pages */\n.multi-query-images {\n  height: 100%;\n}\n\n.query-images-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.query-image-item {\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.query-image-item:hover {\n  border-color: #90caf9;\n}\n\n.query-image-item.highlighted {\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);\n}\n\n.query-image-label {\n  background: #f5f5f5;\n  padding: 0.5rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: #555;\n}\n\n.query-image-item.highlighted .query-image-label {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.query-image-item img {\n  width: 100%;\n  height: auto;\n  max-height: 250px;\n  object-fit: contain;\n  background: #fafafa;\n}\n\n.chip-query-page {\n  font-size: 0.75rem;\n  background: #e3f2fd;\n  color: #1976d2;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n}\n\n/* Responsive */\n@media (max-width: 1000px) {\n  .comparison-panels {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .comparison-divider {\n    padding: 0.5rem 0;\n  }\n\n  .comparison-panel {\n    max-height: none;\n  }\n\n  .query-images-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* NUBBI-102 — botón de entrada a búsqueda por elementos */\n.comparison-header-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.btn-elements-search {\n  padding: 0.6rem 1.2rem;\n  border: 1px solid #3498db;\n  border-radius: 4px;\n  background: #3498db;\n  color: white;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.btn-elements-search:hover {\n  background: #2980b9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
